import { ICON_DEFAULT_COLOR, ICON_DEFAULT_SIZE } from '@constants/icons';
import { IconProps } from '@models/icons';

function Notice({ size = ICON_DEFAULT_SIZE, color = ICON_DEFAULT_COLOR, ...rest }: IconProps) {
    return (
        <svg width={size} height={size} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"
            {...rest}>
            <circle cx="8" cy="8" r="6" fill={color}/>
            <path
                d="M6.68555 10.8613V10.0254H7.48633V7.77148H6.7207V6.93555H8.50977V10.0254H9.31445V10.8613H6.68555ZM7.98242 6.45508C7.80273 6.45508 7.64779 6.39128 7.51758 6.26367C7.38997 6.13346 7.32617 5.97591 7.32617 5.79102C7.32617 5.61133 7.38997 5.45768 7.51758 5.33008C7.64779 5.20247 7.80273 5.13867 7.98242 5.13867C8.16471 5.13867 8.31966 5.20247 8.44727 5.33008C8.57747 5.45768 8.64258 5.61133 8.64258 5.79102C8.64258 5.97591 8.57747 6.13346 8.44727 6.26367C8.31966 6.39128 8.16471 6.45508 7.98242 6.45508Z"
                fill="white"/>
        </svg>
    );
}

export default Notice;
